import {
  EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN,
  EMPLOYEE_STAFF_ON_CHANGE_KEYWORD,
  EMPLOYEE_STAFF_ON_CLICK_EXPORT,
  EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF,
  EMPLOYEE_STAFF_ON_CLICK_ROW,
  EMPLOYEE_STAFF_LIST_STAFF_REQUEST,
  EMPLOYEE_STAFF_LIST_ROLES_REQUEST,
  EMPLOYEE_STAFF_PAGE_REQUEST,
  EMPLOYEE_STAFF_SET_EMPLOYEES,
  EMPLOYEE_STAFF_SET_SUBMITTING,
  EMPLOYEE_STAFF_SET_OUTLETS,
  EMPLOYEE_STAFF_SET_ROLES,
  EMPLOYEE_STAFF_LIST_OUTLET_REQUEST,
  EMPLOYEE_STAFF_ON_CLICK_CANCEL,
  EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL,
  EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_SUBMIT_FORM,
  EMPLOYEE_STAFF_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
  EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
  EMPLOYEE_STAFF_ON_CANCEL_RESEND,
  EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE,
  EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST,
  EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL
} from './constants'

export function openRightColumn () {
  return {type: EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function onChangeKeyword ({keyword, user}) {
  return {type: EMPLOYEE_STAFF_ON_CHANGE_KEYWORD, payload: {keyword, user}}
}

export function onClickInviteStaff () {
  return {type: EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF, payload: {}}
}

export function onClickRow ({employee}) {
  return {type: EMPLOYEE_STAFF_ON_CLICK_ROW, payload: {employee}}
}

export function onClickCancel () {
  return {type: EMPLOYEE_STAFF_ON_CLICK_CANCEL, payload: {}}
}

export function onClickExport ({employees, user}) {
  return {type: EMPLOYEE_STAFF_ON_CLICK_EXPORT, payload: {employees, user}}
}

export function onCancelDeleteEmployee () {
  return {type: EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE, payload: {}}
}

export function onConfirmDeleteEmployee ({employee, previousEmployees}) {
  return {type: EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE, payload: {employee, previousEmployees}}
}

export function onClickDeleteEmployee () {
  return {type: EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE, payload: {}}
}

export function listStaffRequest ({keyword, user, submitFlag}) {
  return {type: EMPLOYEE_STAFF_LIST_STAFF_REQUEST, payload: {keyword, user, submitFlag}}
}

export function listOutletRequest () {
  return {type: EMPLOYEE_STAFF_LIST_OUTLET_REQUEST, payload: {}}
}

export function listRolesRequest () {
  return {type: EMPLOYEE_STAFF_LIST_ROLES_REQUEST, payload: {}}
}

export function listPermissionRequest ({userId}) {
  return {type: EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST, payload: {userId}}
}

export function pageRequest ({user}) {
  return {type: EMPLOYEE_STAFF_PAGE_REQUEST, payload: {user}}
}

export function setEmployees ({employees}) {
  return {type: EMPLOYEE_STAFF_SET_EMPLOYEES, payload: {employees}}
}

export function setOutlets ({outlets}) {
  return {type: EMPLOYEE_STAFF_SET_OUTLETS, payload: {outlets}}
}

export function setCanAccessRole ({canAccessRole}) {
  return {type: EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE, payload: {canAccessRole}}
}

export function setSubmitting ({submitting}) {
  return {type: EMPLOYEE_STAFF_SET_SUBMITTING, payload: {submitting}}
}

export function setEmployeeDetail ({employee}) {
  return {type: EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL, payload: {employee}}
}

export function setRoles ({roles}) {
  return {type: EMPLOYEE_STAFF_SET_ROLES, payload: {roles}}
}

export function showAssignOutletModal () {
  return {type: EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL, payload: {}}
}

export function hideAssignOutletModal () {
  return {type: EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL, payload: {}}
}

export function showEmployeeDeleteModal () {
  return {type: EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL, payload: {}}
}

export function hideEmployeeDeleteModal () {
  return {type: EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL, payload: {}}
}

export function showResendCaptchaModal () {
  return {type: EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL, payload: {}}
}

export function hideResendCaptchaModal () {
  return {type: EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL, payload: {}}
}

export function onCancelAssignOutlet () {
  return {type: EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET, payload: {}}
}

export function onClickAssignOutlet () {
  return {type: EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET, payload: {}}
}

export function onClickResendInvitation ({email}) {
  return {type: EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION, payload: {email}}
}

export function setResendCaptchaEmail ({email}) {
  return {type: EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL, payload: {email}}
}

export function onCancelResend () {
  return {type: EMPLOYEE_STAFF_ON_CANCEL_RESEND, payload: {}}
}

export function onClickResendWithValidCaptcha ({email}) {
  return {type: EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA, payload: {email}}
}

/**
 * @param outlet
 * @return {{type, payload: {outlets: *}}}
 */
export function onConfirmAssignOutlet ({assignedOutletIds}) {
  return {type: EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET, payload: {assignedOutletIds}}
}

export function onSubmitForm ({values, previousEmployees, outlets, role}) {
  return {type: EMPLOYEE_STAFF_ON_SUBMIT_FORM, payload: {values, previousEmployees, outlets, role}}
}

export function resendInvitation ({email}) {
  return {type: EMPLOYEE_STAFF_RESEND_INVITATION, payload: {email}}
}

export function showPinRequiredModal () {
  return {type: EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL, payload: {}}
}

export function setPinRequiredModal ({message}) {
  return {type: EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL, payload: {message}}
}

export function hidePinRequiredModal () {
  return {type: EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL, payload: {}}
}



// WEBPACK FOOTER //
// ./app/actions/employees/staff/staff.js